import { useIsAuthenticated } from "@azure/msal-react";
import { Button } from "@mui/material";
import { AllowedChangesBooleanKey } from "@repo/logic";
import { type FC, useMemo, useState } from "react";

import { AllowedChangesDevTool, Icons } from "@repo/ui";
import { useHasCurrentContactsChange } from "../../hooks/useHasCurrentContactsChange";

export const DataConfig: FC = () => {
	const [acOpen, setAcOpen] = useState(false);
	const isAuthenticated = useIsAuthenticated();
	const { data: hasCurrentContactsChange, isSuccess: hasCurrentContactsChangeSuccess } = useHasCurrentContactsChange({
		enabled: acOpen && isAuthenticated,
	});
	const effectiveFlagValues = useMemo(
		() =>
			hasCurrentContactsChangeSuccess && hasCurrentContactsChange
				? { [AllowedChangesBooleanKey.CanChangeElectronicContacts]: false }
				: undefined,
		[hasCurrentContactsChange, hasCurrentContactsChangeSuccess],
	);

	return (
		<>
			<Button
				startIcon={<Icons.Pig />}
				onClick={() => setAcOpen(true)}
				sx={{ position: "fixed", bottom: "60px", left: "15px", zIndex: 1300 }}
			/>

			<AllowedChangesDevTool
				open={acOpen}
				onClose={() => setAcOpen(false)}
				effectiveFlagValues={effectiveFlagValues}
			/>
		</>
	);
};
